import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import api from "../../../Component/axios_Interceptor/api";
import { Order_count } from "../../../Component/Interface/Order";
import url from "../../../Component/server";
import { fontStyles } from "../../../Component/style/common_font";
import {
  CenterView,
  Icon,
  RowView,
  RowView2,
} from "../../../Component/style/common_style";
import { LineGraph } from "../../../Component/UI/Chart";
import Layout_Admin from "../../../Component/UI/Layout_Admin";

const GraphBox = styled(RowView2)`
  margin-bottom: 1rem;
  div.box {
    flex: 1;
    box-sizing: border-box;
    width: 100%;
    max-height: 35rem;
    aspect-ratio: 8/5;
    padding: 1.5rem;
    background-color: white;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    overflow: hidden;
  }
  div.right {
    margin-right: 1rem;
  }
  @media ${({ theme }) => theme.large} {
    flex-direction: column;
    div.box {
      margin: 0;
      margin-bottom: 1rem;
    }
  }
`;
const LabelBox = styled(RowView)`
  margin-bottom: 1.5rem;
  div.title {
    font-size: 20px;
    ${fontStyles.semiBold}
  }
  div.label {
    font-size: 14px;
    color: #8e8e8e;
    img {
      margin-left: 5px;
      cursor: pointer;
    }
  }
`;
const DeliveryInfo = styled.div`
  display: flex;
  flex-direction: column;
  div.end {
    font-size: 14px;
    color: #8e8e8e;
    cursor: pointer;
  }
`;
const Info = styled(RowView)`
  flex: 1;
  div {
    flex-direction: column;
  }
  div > div {
    margin-top: 1rem;
  }
  div.notArrow {
    margin-left: 1rem;
  }
  div.red {
    color: #eb003b;
  }
  span {
    ${fontStyles.medium}
  }
`;

const Dashborad = () => {
  const Navigate = useNavigate();

  const today = moment(new Date()).format("YYYY.MM.DD");
  const currentMonth = new Date().getMonth() + 1;
  const month_lastdaym = new Date(
    new Date().getFullYear(),
    currentMonth,
    0
  ).getDate();
  const originData = new Array(month_lastdaym).fill(0);

  const [count_결제건수, setCount_결제건수] = useState<number[]>([]);
  const [count_결제자수, setCount_결제자수] = useState<number[]>([]);
  const [count_결제금액, setCount_결제금액] = useState<number[]>([]);

  const [status_미입금, setStatus_미입금] = useState(0);
  const [status_입금확인, setStatus_입금확인] = useState(0);
  const [status_배송준비, setStatus_배송준비] = useState(0);
  const [status_배송완료, setStatus_배송완료] = useState(0);
  const [status_주문취소, setStatus_주문취소] = useState(0);
  const [status_환불처리, setStatus_환불처리] = useState(0);

  const payment_count = async () => {
    // try {
    //   const res = await api.get(url.Communication_url.payment_count);
    //   const data = res.data || [];
    //   const copyArr = [...originData];
    //   data.forEach((item: { order_date: string; payment_count: string }) => {
    //     const idx = parseInt(item.order_date, 10) - 1;
    //     copyArr[idx] = parseInt(item.payment_count, 10);
    //   });
    //   setCount_결제건수(copyArr);
    // } catch (error) {
    //   console.error("데이터 로드 실패1:", error);
    // }
  };
  const payers_count = async () => {
    // try {
    //   const res = await api.get(url.Communication_url.payers_count);
    //   const data = res.data || [];
    //   const copyArr = [...originData];
    //   data.forEach((item: { order_date: string; payers_count: string }) => {
    //     const idx = parseInt(item.order_date, 10) - 1;
    //     copyArr[idx] = parseInt(item.payers_count, 10);
    //   });
    //   setCount_결제자수(copyArr);
    // } catch (error) {
    //   console.error("데이터 로드 실패2:", error);
    // }
  };
  const total_payment = async () => {
    // try {
    //   const res = await api.get(url.Communication_url.total_payment);
    //   const data = res.data || [];
    //   const copyArr = [...originData];
    //   data.forEach((item: { order_date: string; total_payment: string }) => {
    //     const idx = parseInt(item.order_date, 10) - 1;
    //     copyArr[idx] = parseInt(item.total_payment, 10);
    //   });
    //   setCount_결제금액(copyArr);
    // } catch (error) {
    //   console.error("데이터 로드 실패3:", error);
    // }
  };
  const get_order_count = async () => {
    // try {
    //   const res = await api.get(url.Communication_url.get_order_count);
    //   const data = res.data;
    //   data.forEach((item: Order_count) => {
    //     const count = Number(item.cnt);
    //     switch (item.order_status) {
    //       case "미입금":
    //         setStatus_미입금(count);
    //         break;
    //       case "입금확인":
    //         setStatus_입금확인(count);
    //         break;
    //       case "배송준비":
    //         setStatus_배송준비(count);
    //         break;
    //       case "배송완료":
    //         setStatus_배송완료(count);
    //         break;
    //       case "주문취소":
    //         setStatus_주문취소(count);
    //         break;
    //       case "환불처리":
    //         setStatus_환불처리(count);
    //         break;
    //       default:
    //         break;
    //     }
    //   });
    // } catch (error) {
    //   console.error("데이터 로드 실패4:", error);
    // }
  };

  const store_dashboard = async () => {
    try {
      const res = await api.get(url.Communication_url.store_dashboard);

      // 결제건수
      const paymentCountData = res.data.paymentCount || [];
      const paymentCountCopyArr = [...originData];
      paymentCountData.forEach(
        (item: { order_date: string; count: string }) => {
          const idx = parseInt(item.order_date, 10) - 1;
          paymentCountCopyArr[idx] = parseInt(item.count, 10);
        }
      );
      setCount_결제건수(paymentCountCopyArr);

      // 결제자수
      const payersData = res.data.payersCount || [];
      const payersCopyArr = [...originData];
      payersData.forEach((item: { order_date: string; count: string }) => {
        const idx = parseInt(item.order_date, 10) - 1;
        payersCopyArr[idx] = parseInt(item.count, 10);
      });
      setCount_결제자수(payersCopyArr);

      // 결제금액
      const totalPaymentData = res.data.totalPayment || [];
      const totalPaymentCopyArr = [...originData];
      totalPaymentData.forEach(
        (item: { order_date: string; amount: string }) => {
          const idx = parseInt(item.order_date, 10) - 1;
          totalPaymentCopyArr[idx] = parseInt(item.amount, 10);
        }
      );
      setCount_결제금액(totalPaymentCopyArr);

      // 주문/배송
      const orderStatusData = res.data.orderStatus;
      orderStatusData.forEach((item: Order_count) => {
        const count = Number(item.count);
        switch (item.status) {
          case "미입금":
            setStatus_미입금(count);
            break;
          case "입금확인":
            setStatus_입금확인(count);
            break;
          case "배송준비":
            setStatus_배송준비(count);
            break;
          case "배송완료":
            setStatus_배송완료(count);
            break;
          case "주문취소":
            setStatus_주문취소(count);
            break;
          case "환불처리":
            setStatus_환불처리(count);
            break;
          default:
            break;
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        await store_dashboard();
      } catch (error) {
        console.error("요청 중 오류 발생:", error);
      }
    };
    fetchData();
  }, []);

  const go_orderlist = () => Navigate("/admin/orderlist/non-pay");

  return (
    <Layout_Admin menuname={"대시보드"}>
      <GraphBox>
        <div className="box right">
          <LabelBox>
            <div className="title">결제건수</div>
            <div className="label">{currentMonth}월 매출 통계</div>
          </LabelBox>
          <LineGraph graphData={count_결제건수} />
        </div>

        <div className="box">
          <LabelBox>
            <div className="title">결제자수</div>
            <div className="label">{currentMonth}월 매출 통계</div>
          </LabelBox>
          <LineGraph graphData={count_결제자수} />
        </div>
      </GraphBox>

      <GraphBox>
        <div className="box right">
          <LabelBox>
            <div className="title">결제금액</div>
            <div className="label">{currentMonth}월 매출 통계</div>
          </LabelBox>
          <LineGraph graphData={count_결제금액} />
        </div>

        <DeliveryInfo className="box">
          <LabelBox>
            <div className="title">주문/배송</div>
            <RowView2 className="label">
              {today}
              <Icon
                className="reset"
                src={require("../../../Image/ic_reset_gray.png")}
                onClick={store_dashboard}
              />
            </RowView2>
          </LabelBox>

          <Info>
            <CenterView>
              <Icon
                src={require("../../../Image/Admin/ic_info_money_no.png")}
              />
              <div>미입금</div>
              <div>
                <span>{status_미입금}</span> 건
              </div>
            </CenterView>
            <Icon src={require("../../../Image/ic_arrow_right_gray2.png")} />
            <CenterView>
              <Icon
                src={require("../../../Image/Admin/ic_info_money_yes.png")}
              />
              <div>입금확인</div>
              <div>
                <span>{status_입금확인}</span> 건
              </div>
            </CenterView>
            <Icon src={require("../../../Image/ic_arrow_right_gray2.png")} />
            <CenterView>
              <Icon
                src={require("../../../Image/Admin/ic_info_delivery_ready.png")}
              />
              <div>배송준비</div>
              <div>
                <span>{status_배송준비}</span> 건
              </div>
            </CenterView>
            <Icon src={require("../../../Image/ic_arrow_right_gray2.png")} />
            <CenterView>
              <Icon
                src={require("../../../Image/Admin/ic_info_delivery_done.png")}
              />
              <div>배송완료</div>
              <div>
                <span>{status_배송완료}</span> 건
              </div>
            </CenterView>
            <CenterView className="notArrow">
              <Icon
                src={require("../../../Image/Admin/ic_info_order_cancle.png")}
              />
              <div className="red">주문취소</div>
              <div>
                <span>{status_주문취소}</span> 건
              </div>
            </CenterView>
            <CenterView className="notArrow">
              <Icon
                src={require("../../../Image/Admin/ic_info_money_no.png")}
              />
              <div>환불처리</div>
              <div>
                <span>{status_환불처리}</span> 건
              </div>
            </CenterView>
          </Info>

          <RowView2 className="end">
            <div onClick={go_orderlist}>주문내역 보기 {">"}</div>
          </RowView2>
        </DeliveryInfo>
      </GraphBox>
    </Layout_Admin>
  );
};

export default Dashborad;
